import 'react';
import PropTypes from 'prop-types';

var rowType = PropTypes.oneOf(['default', 'info', 'success', 'warning', 'error']);

var rowAccent = PropTypes.oneOf([false, 'gray', 'orange', 'pink', 'red', 'green', 'purple']);

export default { rowType: rowType, rowAccent: rowAccent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-table/es/TablePropTypes.js
// module id = 323
// module chunks = 0